import { LinkedList, ListNode } from '@spotify-internal/linkedlist';
export class CDNURLTracker {
    constructor() {
        this._version = '1.0.0';
        this._list = new LinkedList();
        this._map = {};
    }
    clear() {
        this._list = new LinkedList();
        this._map = {};
    }
    track(url, data) {
        let entry = this._map[url];
        if (!entry) {
            entry = new ListNode({
                url,
                segments: 0,
                bandwidths: [],
            });
            this._list.append(entry);
            this._map[url] = entry;
        }
        const { value } = entry;
        if (value) {
            value.segments += 1;
            value.bandwidths.push(data.bandwidth);
        }
    }
    toJSON() {
        const urls = [];
        let current = this._list.first;
        while (current) {
            const { value } = current;
            if (!value) {
                continue;
            }
            // Calculate average bandwidth.
            const { bandwidths } = value;
            let total = 0;
            let len = bandwidths.length;
            while (len--) {
                total += bandwidths[len];
            }
            urls.push({
                url: value.url,
                segments: value.segments,
                avg_bw: parseFloat((total / bandwidths.length).toFixed(7)),
            });
            current = current.next;
        }
        return {
            version: this._version,
            urls,
        };
    }
}
//# sourceMappingURL=cdn_url_tracker.js.map